import ResetPasswordPage from '@/pages/login/reset-password/reset-password';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_public/reset-password')({
  component: ResetPasswordPage,
  validateSearch: search => {
    return { token: (search.token ?? '') as string };
  },
});
